// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__f_4NV","error":"Textarea_error__1GKpb","readonly":"Textarea_readonly__1_fLG","disabled":"Textarea_disabled__w0D2s"};